<template>
	<div class="nav-search" :class="{'nav-search--searching': search.length}">
		<CInput
			id="search"
			ref="searchRef"
			v-model="search"
			type="search"
			placeholder="Search"
			class="relative my-2"
			@input="$emit('search', search)"
			@blur="$emit('blur', $event)"
			@focus="$emit('focus', $event)"
		>
			<template #prefix>
				<Inline svg="search" class="text-icon-subtle" />
			</template>
		</CInput>
	</div>
</template>

  <script lang="ts">
	import CInput from 'src/components/form-controls/Input.vue';
	import { isMobileKey } from 'src/utilities/injection-keys';
	import { defineComponent, ref, inject, onMounted, watch } from 'vue';
	import { useRoute } from 'vue-router/composables';
	import { ClearSearchEvent, useEventBus } from 'src/views/admin/utils/useEventBus';

	export default defineComponent({
		name: 'CNavSearch',
		components: {
			CInput
		},
		emits: ['search', 'blur', 'focus'],
		setup(_, { emit }) {
			const search = ref<string>('');
			const searchRef = ref<HTMLElement>(null);
			const route = useRoute();

			const isMobile = inject(isMobileKey);

			onMounted(() => {
				if (isMobile.value)
					return;
				searchRef.value?.focus();
			});

			const clearSearch = (focusSearch: boolean) => {
				if (search.value.length) {
					search.value = '';
					emit('search', search.value);
				}
				if (focusSearch)
					searchRef.value?.focus();
			};

			watch(() => route.path, () => {
				clearSearch(false);
				emit('blur');
			});

			const { on: onClearSearchEvent } = useEventBus(ClearSearchEvent);
			onClearSearchEvent(() => {
				clearSearch(false);
				emit('blur');
			});

			return {
				search,
				searchRef,
				clearSearch
			};
		}
	});
  </script>

  <style lang="scss">
	.nav-search {

		input[type='search'] {

			/* clears the ‘X’ from Chrome, Safari, FF */
			&::-webkit-search-cancel-button {
				display: none;
			}

			&:focus {
				border-color: var(--outline-focused);
				transition: border .2s;
			}
		}

		&--searching {

			.el-input__suffix {
				pointer-events: initial;
			}
		}
	}
  </style>
